import React, { useEffect, useState } from 'react';
import styles from './../../Assets/CSS/Sidebar.module.css';
import axios from 'axios';
import { BASE_URL, BASE_FILE_URL } from './../../Environment'; 
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom';
import { IoSearch } from 'react-icons/io5';

function Sidebar() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [category, setCategory] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');  
    useEffect(() => {
        axios.get(`${BASE_URL}/category`, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            setCategory(res.data.data);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
        });
    }, []); 
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    }; 
    const filteredCategories = category.filter((data) =>
        data.name.toLowerCase().includes(searchQuery.toLowerCase())
    );   
    const navigate = useNavigate();  
    const handleClick = (slug) => {
        navigate(`/listing/${slug}`); 
    }  

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };
    return (
        <div className="side-menu-bar"> 
             <div id="side-menu-bar" className={`${styles.sidebar} ${isSidebarOpen ? 'sidebar-res' : ''}`}>
                <button className={`sidebar-btn ${isSidebarOpen ? 'side-btn-res' : ''}`} onClick={toggleSidebar}>
                    <svg width="16" height="16" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="1.25" y="1.25" width="93.5" height="93.5" rx="46.75" fill="#E3F4FD" />
                        <rect x="1.25" y="1.25" width="93.5" height="93.5" rx="46.75" stroke="#0473A8" stroke-width="2.5" />
                        <path d="M30.4219 73H48C52.0384 73 55.3242 69.7142 55.3242 65.6758V30.3242C55.3242 26.2858 52.0384 23 48 23H30.4219C29.6122 23 28.957 23.6552 28.957 24.4648C28.957 25.2745 29.6122 25.9297 30.4219 25.9297H48C50.4232 25.9297 52.3945 27.901 52.3945 30.3242V65.6758C52.3945 68.099 50.4232 70.0703 48 70.0703H30.4219C29.6122 70.0703 28.957 70.7255 28.957 71.5352C28.957 72.3448 29.6122 73 30.4219 73Z" fill="#0473A8" />
                        <path d="M28.957 65.5781C28.957 66.3878 29.6122 67.043 30.4219 67.043H48C48.8097 67.043 49.4648 66.3878 49.4648 65.5781V59.7188C49.4648 58.9091 48.8097 58.2539 48 58.2539H30.4219C29.6122 58.2539 28.957 58.9091 28.957 59.7188V65.5781ZM28.957 50.9297C28.957 51.7394 29.6122 52.3945 30.4219 52.3945H48C48.8097 52.3945 49.4648 51.7394 49.4648 50.9297V45.0703C49.4648 44.2606 48.8097 43.6055 48 43.6055H30.4219C29.6122 43.6055 28.957 44.2606 28.957 45.0703V50.9297ZM30.4219 37.7461H48C48.8097 37.7461 49.4648 37.0909 49.4648 36.2812V30.4219C49.4648 29.6122 48.8097 28.957 48 28.957H30.4219C29.6122 28.957 28.957 29.6122 28.957 30.4219V36.2812C28.957 37.0909 29.6122 37.7461 30.4219 37.7461Z" fill="#0473A8" />
                    </svg>
                </button>
                <div className="inputContainer mx-auto w-100"> 
                    <input type="text" className="input" value={searchQuery} placeholder="Search..." onChange={handleSearchChange} />
                    <IoSearch color="rgb(18,95,220)" /> 
                </div>    
                <div className={`${styles.sidebarMenu} ${isSidebarOpen ? 'side-menu-res' : ''}`}>
                    {filteredCategories?.map((data, i) => ( 
                        <div className={styles.menuItem} key={i} onClick={() => handleClick(data.slug)}>   
                            <div className={styles.menuItemLeft}>  
                                <div className={styles.iconContainer}>
                                    <img src={BASE_FILE_URL + data.image} className={styles.icon} />
                                </div> 
                            </div>
                            <div className={styles.menuItemName}>{data.name}</div>
                        </div > 
                    ))}
                </div>  
            </div>
        </div>
    );
}

export default Sidebar;  